export const sxStyle = {
  root: {
    minHeight: '50vh',
    padding: {
      xs: '10px',
      sm: '50px 100px',
    },
  },

  contentSkeleton: {
    display: 'flex',
    flexDirection: 'column',
    paddingLeft: {
      xs: 0,
      sm: '30px',
    },
    marginTop: {
      xs: 0,
      sm: 0,
    },
  },

  cardSkeleton: {
    width: '100%',
    height: {
      xs: '400px',
      sm: '200px',
    },
    borderRadius: '8px',
    margin: '20px 0px',
  },
};
